<template>
  <div id="magic-zoom">
    <div itemscope itemtype="http://schema.org/Thing" >
      <div class="ItemImgWrap justify-content-center" :class="[{'more-images': magiczoom.images.all.length > 1 },{'d-none':gallery !== true},{'hundredYearBadge-box' : hundredYears }]">
        <template v-if="magiczoom.images.all.length > 1">
          <div class="magic-more-images d-none d-lg-block" v-if="variationImages > 4 || variationImages.length > 4">
            <div @click="slidePrev" class="text-center fa-lg mb-2 cursor" v-if="magiczoom.images.all.length > 4">
              <i class="fa fa-angle-right fa-rotate-270 flipiconZoom "></i>
            </div>
            <hooper class="d-none d-lg-block" :vertical="true" :infiniteScroll="false" :itemsToShow="4" :trimWhiteSpace="true" ref="carousel">
              <slide v-if="ytvideo !=''">
                <a class="border video d-flex mb-2 videoImage cursor" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                  <i class="fa fa-play-circle-o" v-if="!loading"></i>
                  <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                </a>
              </slide>
              <slide v-for="(imagePreview, index) in variationImages">
                <a :aria-label="'variationImages'+index" href="variationImages[index].url" rel="zoom-id:ItemImgZoom" :data-image="variationImages[index].urlMiddle" class="border">
                  <img
                      loading="lazy"
                      :data-src="imagePreview.url"
                      :src="imagePreview.urlPreview"
                      :alt="magiczoom.texts.name1+' - '+index"
                      :title="magiczoom.texts.name1+' - '+index">
                </a>
              </slide>
            </hooper>
            <div @click="slideNext" class="text-center fa-lg cursor" v-if="magiczoom.images.all.length > 4">
              <i class="fa fa-angle-right fa-rotate-90"></i>
            </div>
          </div>
          <div class="magic-more-images d-none d-lg-block" v-else>
            <template v-if="ytvideo !=''">
              <a class="border video d-flex mb-2 videoImage" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                <i class="fa fa-play-circle-o" v-if="!loading"></i>
                <i class="fa fa-circle-o-notch fa-spin" v-else></i>
              </a>
            </template>
            <template v-for="(imagePreview, index) in variationImages">
              <a :aria-label="'variationImages'+index" :href="variationImages[index].url" rel="zoom-id:ItemImgZoom" :data-image="variationImages[index].urlMiddle" class="mb-2 border">
                <img
                    loading="lazy"
                    :data-src="imagePreview.url"
                    :src="imagePreview.urlPreview"
                    :alt="magiczoom.texts.name1+' - '+index"
                    :title="magiczoom.texts.name1+' - '+index">
              </a>
            </template>
          </div>
        </template>

        <a :aria-label="$translate('Woerner::Template.singleZoomHint')" :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
           :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Woerner::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Woerner::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Woerner::Template.singleZoomHint')"
           :data-options="'lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:'+$translate('Woerner::Template.singleZoomHint3')+'; textExpandHint:'+ $translate('Woerner::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'">

          <img  alt="middleImage" class="img-fluid" :src="magiczoom.images | itemImages('urlMiddle') | itemImage" itemprop="image">
        </a>
        <template v-if="hundredYears">
          <div class="hundredYearBadge-box">
            <img :alt="'100 years'" :src="'https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/100Jahre_Icon_'+ lang.toUpperCase() +'.png'" loading="lazy" class="hundredYearBadge">
          </div>
        </template>
        <div v-if="geticons.hasOwnProperty('84')" class="item-characters d-flex">
          <template v-for="icon in geticons[84]" >
            <template v-if="icon.id == 1503">
              <div class="character">
                <img src="https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_schwerentflammbar.gif" alt="schwerentflammbar">
              </div>
              <!-- schwer entflammbar -->
            </template>
            <template v-if="icon.id == 1506">
              <div class="character">
                <img src="https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_aussen_innen.gif" alt="fuer aussenanwendung">
              </div>
              <!-- für aussen -->
            </template>
          </template>
        </div>
      </div>
      <template v-if="magiczoom.prices.rrp && magiczoom.prices.rrp.price.value > 0 && magiczoom.prices.rrp.price.value > magiczoom.prices.default.price.value">
        <div class="item-special-icon reduced">
          %
        </div>
      </template>
      <template v-if="gallery != true">
        <div>
          <iframe width="100%" height="315" :src="'https://www.youtube-nocookie.com/embed/'+ytvideo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
          </iframe>
        </div>
      </template>
      <template v-if="gallery == true">
        <div class="zoom-navigation-dots d-lg-none">
          <template v-for="dot in dotsCount">
            <div class="dot"></div>
          </template>
        </div>
      </template>
      <template v-if="ytvideo != '' && gallery != true" >
        <div class="d-md-none text-center my-3 ybbGalleryBtn">
          <button @click="gallery = true" class="btn btn-primary">
            Gallery anzeigen <i class="fa fa-picture-o ml-3"></i>
          </button>
        </div>
      </template>
      <template v-if="ytvideo != '' && gallery == true" >
        <div class="d-md-none text-center my-3">
          <button @click="gallery = false" class="btn btn-primary">
            Video abspielen <i class="fa fa-play-circle-o ml-3"></i>
          </button>
        </div>
      </template>

      <!-- icons here -->

      <template v-for="icon in geticons[83]" v-if="geticons.hasOwnProperty('83')">
        <template v-if="icon.id == 1499">
          <div class="item-special-icon reduced">
            %
          </div>
          <!-- Reduziert -->
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide  } from 'hooper';
export default
{
  name:'magic-zoom',
  components: { Hooper, Slide },
  props:
      {
        template:
            {
              type: String,
              default: "#vue-magic-zoom"
            }
      },
  inject:
      {
        itemId:
            {
              default: null
            }
      },
  data: function()
  {
    return {
      gallery:true,
      onloadVarId: this.currentVariation().variation.id,
      dotsCount: 0,
      loading:false,
      youtubeid:'',
      variationImages:[]
    }
  },
  methods:
      {
        showVideo:function()
        {
          let _self = this;
          _self.loading = true;
          vueEventHub.$emit("youtube-id",this.youtubeid);

          setTimeout(function () {
            $('#yt-single').modal('show');
            _self.loading = false;
          },500)

        },
        searchVideo()
        {
          let currentVariation = this.currentVariation();
          let _self = this;
          if(currentVariation.hasOwnProperty('variationProperties'))
          {
            for(let i=0; i < currentVariation.variationProperties.length; i++)
            {
              if(currentVariation.variationProperties[i].id == 3)
              {
                for(let v=0; v < currentVariation.variationProperties[i].properties.length; v++)
                {
                  if(currentVariation.variationProperties[i].properties[v].id == 76)
                  {
                    if(currentVariation.variationProperties[i].properties[v].values.value !="")
                    {
                      this.youtubeid = currentVariation.variationProperties[i].properties[v].values.value;
                    }
                  }
                }
              }
            }
            return this.youtubeid;
          }
          else
          {
            return '';
          }
        },
        getCurrentImages:function()
        {
          let _self = this;
          let current = this.currentVariation();
          if(current.images.variation.length > 0)
          {
            _self.variationImages =  current.images.variation
          }
          else
          {
            _self.variationImages =  current.images.all
          }
        },
        currentVariation: function()
        {
          return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        slideNext() {
          this.$refs.carousel.slideNext();
        },
        slidePrev() {
          this.$refs.carousel.slidePrev();
        }
      },
  computed:
      {
        lang()
        {
          return App.language
        },
        hundredYears() {
          let current = this?.magiczoom;
          if(current?.hasOwnProperty('tags'))
          {
            const tags = current?.tags;
            const hundredYears = tags?.filter(tag => tag.id == 330);
            return (hundredYears?.length > 0);
          }
          return false

        },
        magiczoom: function()
        {
          this.getCurrentImages();
          return this.currentVariation();
        },
        ytvideo:function()
        {
          return this.searchVideo();
        },
        geticons: function()
        {
          let currentVariation = this.currentVariation();
          let icons = {};
          let ids = [84,83]
          ids.forEach(function(groupid)
          {
            if(currentVariation.hasOwnProperty('variationProperties'))
            {
              for(let i=0; i < currentVariation.variationProperties.length; i++)
              {
                if(currentVariation.variationProperties[i].id == 6)
                {
                  for(let p = 0; p < currentVariation.variationProperties[i].properties.length; p++)
                  {
                    if(currentVariation.variationProperties[i].properties[p].id == groupid )
                    {
                      if(!Array.isArray(currentVariation.variationProperties[i].properties[p].values))
                      {
                        icons[groupid] = [];
                        icons[groupid].push(
                            {
                              "id":currentVariation.variationProperties[i].properties[0].values.selectionId,
                              "name":currentVariation.variationProperties[i].properties[0].values.value
                            }
                        )
                      }
                      else
                      {
                        icons[groupid] = [];
                        for(let o = 0; o < currentVariation.variationProperties[i].properties[p].values.length; o++)
                        {
                          icons[groupid].push(
                              {
                                "id":currentVariation.variationProperties[i].properties[p].values[o].selectionId,
                                "name":currentVariation.variationProperties[i].properties[p].values[o].value
                              }
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          });
          return icons;
        }

      }
}
</script>
